var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconJobs = function SvgIconJobs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5047ff",
    d: "M21.167 3.001H2.833A1.833 1.833 0 0 0 1 4.834v.611h22v-.611a1.834 1.834 0 0 0-1.833-1.833M1 18.279a1.834 1.834 0 0 0 1.833 1.833h18.334A1.833 1.833 0 0 0 23 18.279V6.668H1Zm14.056-9.167h4.889a.611.611 0 0 1 0 1.222h-4.889a.611.611 0 0 1 0-1.222m0 2.444h4.889a.611.611 0 0 1 0 1.222h-4.889a.611.611 0 1 1 0-1.222m0 2.444h4.889a.611.611 0 0 1 0 1.222h-4.889a.611.611 0 0 1 0-1.222M7.722 9.112a2.444 2.444 0 1 1-2.444 2.444 2.445 2.445 0 0 1 2.444-2.444m-2.444 6.111h4.889A1.833 1.833 0 0 1 12 17.057a.61.61 0 0 1-.611.611H4.056a.61.61 0 0 1-.611-.611 1.834 1.834 0 0 1 1.833-1.834",
    "data-name": "Group 1787"
  })));
};
export default SvgIconJobs;